import { SxProps, Theme } from '@mui/material/styles';

export const SECTION_ROOT_STYLES: SxProps<Theme> = {
  overflow: 'visible',
  boxShadow: 'none',
};

export const SECTION_HEADER_STYLES: SxProps<Theme> = {
  padding: (theme) => theme.spacing(0, 2),
  height: (theme) => theme.spacing(4.5),
  color: (theme) => theme.palette.text.secondary,
  '& .MuiTypography-root': {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
};
